import { render, staticRenderFns } from "./adsIndex.vue?vue&type=template&id=64f06be0&scoped=true&"
import script from "./adsIndex.vue?vue&type=script&lang=js&"
export * from "./adsIndex.vue?vue&type=script&lang=js&"
import style0 from "./adsIndex.vue?vue&type=style&index=0&id=64f06be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f06be0",
  null
  
)

export default component.exports